import { useMutation, useQueryClient } from "@tanstack/react-query";
import { merchantKeys } from "Api/Queries/Merchants/useGetMerchantQuery";
import { getMerchantTerminalContractsQueryKey } from "Api/Queries/Merchants/useGetMerchantTerminalContractsQuery";
import {
  type CreateMerchantTerminalContractDto,
  type MerchantTerminalContractDto,
  postMerchantsPublicIDTerminalContracts,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
  merchantPublicID: string;
};

export const useCreateMerchantTerminalContractMutation = ({
  onSuccess,
  onError,
  merchantPublicID,
}: Props) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (parameters: CreateMerchantTerminalContractDto) =>
        postMerchantsPublicIDTerminalContracts(parameters, merchantPublicID),
    ),
    onSuccess: (_, { merchantPublicID }: MerchantTerminalContractDto) => {
      queryClient.invalidateQueries({
        queryKey: merchantKeys.byMerchantPublicId(merchantPublicID),
      });
      queryClient.invalidateQueries({
        queryKey: getMerchantTerminalContractsQueryKey(merchantPublicID),
      });
      onSuccess?.();
    },
    onError,
  });
};
